<template>
  <div
    v-if="active"
    :id="panelId(tabs.base, value)"
    class="ui-tabs-content"
    role="tabpanel"
    :aria-labelledby="tabId(tabs.base, value)"
    tabindex="0"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { panelId, tabId, useTabs } from './context'

const props = defineProps<{ value: string }>()

const tabs = useTabs('TabsContent')
const active = computed(() => tabs.current.value === props.value)
</script>

<style scoped>
.ui-tabs-content {
  padding-top: var(--space-4);
}

.ui-tabs-content:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
  border-radius: var(--radius-md);
}
</style>
